<template>
  <div id="page-content" tabindex="-1">
    <span aria-label="Cancel Confirmation Page" aria-live="polite" role="contentinfo"></span>
    <h2 class="public-h5 font-weight-bold mt-5 mb-5">
      {{ siteText.ui.cancelConfirmationPageHeader }}
    </h2>
    <p class="text-h8 font-weight-bold">
      {{ siteText.ui.cancelConfirmationPageSubHeader }}
    </p>
    <p class="text-h8">
      {{ siteText.ui.cancelConfirmationPageSubHeader2 }}
    </p>
    <!-- <v-card>
      <v-card-text class="centerContainer">
        <reservation-details :booking="cancelledBooking"></reservation-details>
      </v-card-text>
    </v-card>
    <p></p> -->
    <div class="text-left pt-4">
      <v-layout row wrap>
      <v-flex md3>
        <v-btn
          class="ma-2 dmv-btn"
          height="45px"
          width="260px"
          @click="cancelConfirmNewReservation()"
        >
          {{ siteText.ui.cancelConfirmNewReservation }}
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import ReservationDetails from '@/components/ReservationDetails.vue';
export default {
  name: 'CancelConfirmationPage',
  // components: {ReservationDetails},
  methods: {
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    back() {
      this.$emit('navigateTo', 'CancelReservationPage');
    },
    cancelConfirmNewReservation() {
      this.$emit('navigateTo', 'NewReservationPage', { 
          pageName:'Schedule a Reservation'
      });
    },
},
  computed: {
    ...mapGetters(['siteText']),
    ...mapGetters(['cancelledBooking','isRTLLangauge'])
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}
</style>
